import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { AdvtService } from "../_services/advt.service";
import { AlertService } from "../_services/alert.service";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";

//import { environment } from '../../../../environments/environment';

@Component({
  selector: "app-home-serach",
  templateUrl: "./home-serach.component.html",
  styleUrls: ["./home-serach.component.css"],
})
export class HomeSerachComponent implements OnInit {
  @ViewChild("template_new") template_new: TemplateRef<any>;

  logoimage: any;
  showSearch = true;
  modalRef: BsModalRef;
  cartIco: any;
  searchIco: any;
  public current_lat = "";
  public current_lng = "";
  public keyword = "";
  public distance = 0;
  public distance_type = "";
  public category = "";
  public subCategory = "";
  public hideSubCategory = true;
  public escrow_service = null;
  searchData: any;
  searchLength: any;
  currentlat;
  location;
  lat;
  long;
  public categoryData;
  public subCategoryData;
  pageSize = 9;
  pageNo = 1;
  totalPage = [1];
  del = false;
  public searchSubmit = false;
  currentUser: any;
  loading: Boolean = false;
  mainLoader;
  NAP;
  butDisabled: boolean = false;
  tradeIco;
  freeIco;

  constructor(
    private modalService: BsModalService,
    private router: Router,
    private route: ActivatedRoute,
    private _AdvtService: AdvtService,
    private _alertService: AlertService
  ) {
    const userInfo = JSON.parse(localStorage.getItem("currentUser"));
    this.currentUser = userInfo ? userInfo.result : null;
  }
  ngOnInit() {
    // this.route.params.subscribe(params => {
    // });
    this.route.queryParams.subscribe((res) => {      
    });
    const id = this.route.snapshot.paramMap.get("id");
    this.showSearch = true;
    this.NAP = "../../assets/images/nap.jpg";
    this.mainLoader = "../../assets/images/BigLoader.gif";
    this.logoimage = "../../assets/images/logomain.png";
    this.cartIco = "../../assets/images/cart-ico.png";
    this.searchIco = "../../assets/images/search-ico.png";
    this.tradeIco = "../../assets/images/Tradeicon.png";
    this.freeIco = "../../assets/images/free.png";
    this.getlocation();
    this.getCategory();
    // setTimeout(() => {
    //   if (this.currentUser) {
    //     this.searchitems();
    //   }
    // }, 1000);
  }

  flipTheSearch(status: any) {
    if (status === 1) {
      this.showSearch = true;
    }
    if (status === 0) {
      this.showSearch = false;
    }
  }

  /**
   * Function to open modal
   * @param template
   */
  public openModal(template: TemplateRef<any>) {
    if (!this.currentUser) {
      this.modalRef = this.modalService.show(
        template,
        Object.assign({}, { class: "gray modal-md" })
      );
      
    } else {
      if (this.currentUser) {
        this.loading = true;
        const params = {
          offset: 0,
          limit: this.pageSize,
          sortOrder: "desc",
          sortByColumn: "updated_at",
          current_lat: this.lat ? this.lat : "",
          current_lng: this.long ? this.long : "",
          keywords: this.keyword ? this.keyword : null,
          distance: this.distance ? this.distance : 0,
          distance_type: this.distance_type ? this.distance_type : "mi",
          category: this.category ? this.category : "",
          category_meta_id: this.subCategory ? this.subCategory : "",
          escrow_service: this.escrow_service ? this.escrow_service : null,
          seller_id: this.currentUser ? this.currentUser.id : "",
        };
        if (
          params.seller_id != "" ||
          params.current_lat != "" ||
          params.current_lng != "" ||
          params.keywords != "" ||
          params.distance != 0 ||
          params.distance_type != "" ||
          params.category != "" ||
          params.escrow_service != ""
        ) {
          this.loading = true;
          this.searchData = [];
          this.del = true;
          this._AdvtService.searchData(params).subscribe((data) => {
            if (data.result) {
              this.searchData = data.result;
              this.searchLength = data.count;
              this.loading = false;
              this.del = false;
            } else {
              this.searchData = [];
              this.searchLength = 0;
              this.openModal2(this.template_new);
              this.loading = false;
            }
          });
        } else {
          this.loading = true;
          this.searchData = [];
          this.del = true;
          this._AdvtService.searchData(params).subscribe((data) => {
            if (data.result) {
              this.searchData = data.result;
              this.searchLength = data.count;
              this.loading = false;
              this.del = false;
            } else {
              this.searchData = [];
              this.searchLength = 0;
              this.openModal2(this.template_new);              
              this.loading = false;
            }
          });
        }
      }
    }
  }

  /**
   * function to get the geolocation
   */
  public getlocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location = position.coords;
        this.lat = position.coords.latitude;
        this.long = position.coords.longitude;
      });
    }
  }

  /**
   * Get Tariff for drop down
   *
   */
  public getCategory(): void {
    // event will give you full breif of action
    this._AdvtService.getAllCategories().subscribe(
      (categorydata) => {
        this.categoryData = categorydata;
      },
      (error) => {
        this._alertService.error(error);
      }
    );
  }

  public getSubCategory(): void {
    this._AdvtService.getAllSubCategories(this.category).subscribe(
      (subCategorydata) => {
        this.subCategoryData = subCategorydata;
      },
      (error) => {
        this._alertService.error(error);
      }
    );
  }

  public onCategoryChange(value) {
    if (value !== "" && value !== "2" && value !== "4" && value !== "5") {
      this.hideSubCategory = false;
      this.getSubCategory();
    } else {
      this.hideSubCategory = true;
      this.subCategoryData = [];
    }
    if (value == "4") {
      this.butDisabled = true;
      this.escrow_service = null;
    } else {
      this.butDisabled = false;
    }
  }

  /**
   * This function is used for pagination
   * @param data
   */
  pagingAgent(data) {
    this.searchData = [];
    this.loading = true;
    this.pageNo = data * this.pageSize - this.pageSize;
    const params = {
      offset: this.pageNo,
      limit: this.pageSize,
      sortOrder: "desc",
      sortByColumn: "distance",
      current_lat: this.lat ? this.lat : "",
      current_lng: this.long ? this.long : "",
      keywords: this.keyword ? this.keyword : null,
      distance: this.distance ? this.distance : 0,
      distance_type: this.distance_type ? this.distance_type : "mi",
      category: this.category ? this.category : "",
      escrow_service: this.escrow_service ? this.escrow_service : null,
      seller_id: this.currentUser ? this.currentUser.id : "",
    };
    if (this.currentUser) {
      this.searchData = [];
      this._AdvtService.searchData(params).subscribe((data) => {
        this.searchData = data.result;
        this.loading = false;
      });
    }
  }

  saveSearch() {
    this.loading = true;
    const params = {
      current_lat: this.lat ? this.lat : "",
      current_lng: this.long ? this.long : "",
      keywords: this.keyword ? this.keyword : null,
      radius: this.distance ? this.distance : "25",
      distance_type: this.distance_type ? this.distance_type : "mi",
      category: this.category ? this.category : "",
      escrow_service: this.escrow_service ? this.escrow_service : null,
      seller_id: this.currentUser ? this.currentUser.id : "",
    };
    this._AdvtService.saveData(params).subscribe((data) => {
      this.loading = false;
      if (data.status == 200) {
        this._hidemodal(this.template_new);
      }
    });
  }

  loginroute() {
    this.modalRef.hide();
    this.router.navigate(["/login"]);
  }

  _signuproute() {
    this.modalRef.hide();
    this.router.navigate(["/register"]);
  }

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }

  /**
   * Function to open modal
   * @param template
   */
  openModal2(template_new: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template_new,
      Object.assign({}, { class: "gray modal-md" })
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/home-serach/home-serach.component.ts